/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardSortParamsDTO } from './LeaderboardSortParamsDTO';
import {
    LeaderboardSortParamsDTOFromJSON,
    LeaderboardSortParamsDTOFromJSONTyped,
    LeaderboardSortParamsDTOToJSON,
} from './LeaderboardSortParamsDTO';
import type { LeaderboardViewColumnListDTO } from './LeaderboardViewColumnListDTO';
import {
    LeaderboardViewColumnListDTOFromJSON,
    LeaderboardViewColumnListDTOFromJSONTyped,
    LeaderboardViewColumnListDTOToJSON,
} from './LeaderboardViewColumnListDTO';
import type { LeaderboardGroupParamsDTO } from './LeaderboardGroupParamsDTO';
import {
    LeaderboardGroupParamsDTOFromJSON,
    LeaderboardGroupParamsDTOFromJSONTyped,
    LeaderboardGroupParamsDTOToJSON,
} from './LeaderboardGroupParamsDTO';

/**
 * 
 * @export
 * @interface TableViewParamsDTO
 */
export interface TableViewParamsDTO {
    /**
     * 
     * @type {LeaderboardViewColumnListDTO}
     * @memberof TableViewParamsDTO
     */
    columnList: LeaderboardViewColumnListDTO;
    /**
     * 
     * @type {boolean}
     * @memberof TableViewParamsDTO
     */
    experimentsOnly?: boolean;
    /**
     * 
     * @type {LeaderboardGroupParamsDTO}
     * @memberof TableViewParamsDTO
     */
    groupOptions?: LeaderboardGroupParamsDTO;
    /**
     * 
     * @type {string}
     * @memberof TableViewParamsDTO
     */
    nameSearchMode?: TableViewParamsDTONameSearchModeEnum;
    /**
     * 
     * @type {string}
     * @memberof TableViewParamsDTO
     */
    nameSearchQuery?: string;
    /**
     * 
     * @type {string}
     * @memberof TableViewParamsDTO
     */
    query?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TableViewParamsDTO
     */
    runsLineage?: boolean;
    /**
     * 
     * @type {LeaderboardSortParamsDTO}
     * @memberof TableViewParamsDTO
     */
    sortOptions: LeaderboardSortParamsDTO;
}


/**
 * @export
 */
export const TableViewParamsDTONameSearchModeEnum = {
    Substring: 'substring',
    Regexp: 'regexp'
} as const;
export type TableViewParamsDTONameSearchModeEnum = typeof TableViewParamsDTONameSearchModeEnum[keyof typeof TableViewParamsDTONameSearchModeEnum];


/**
 * Check if a given object implements the TableViewParamsDTO interface.
 */
export function instanceOfTableViewParamsDTO(value: object): value is TableViewParamsDTO {
    if (!('columnList' in value) || value['columnList'] === undefined) return false;
    if (!('sortOptions' in value) || value['sortOptions'] === undefined) return false;
    return true;
}

export function TableViewParamsDTOFromJSON(json: any): TableViewParamsDTO {
    return TableViewParamsDTOFromJSONTyped(json, false);
}

export function TableViewParamsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TableViewParamsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'columnList': LeaderboardViewColumnListDTOFromJSON(json['columnList']),
        'experimentsOnly': json['experimentsOnly'] == null ? undefined : json['experimentsOnly'],
        'groupOptions': json['groupOptions'] == null ? undefined : LeaderboardGroupParamsDTOFromJSON(json['groupOptions']),
        'nameSearchMode': json['nameSearchMode'] == null ? undefined : json['nameSearchMode'],
        'nameSearchQuery': json['nameSearchQuery'] == null ? undefined : json['nameSearchQuery'],
        'query': json['query'] == null ? undefined : json['query'],
        'runsLineage': json['runsLineage'] == null ? undefined : json['runsLineage'],
        'sortOptions': LeaderboardSortParamsDTOFromJSON(json['sortOptions']),
    };
}

export function TableViewParamsDTOToJSON(value?: TableViewParamsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'columnList': LeaderboardViewColumnListDTOToJSON(value['columnList']),
        'experimentsOnly': value['experimentsOnly'],
        'groupOptions': LeaderboardGroupParamsDTOToJSON(value['groupOptions']),
        'nameSearchMode': value['nameSearchMode'],
        'nameSearchQuery': value['nameSearchQuery'],
        'query': value['query'],
        'runsLineage': value['runsLineage'],
        'sortOptions': LeaderboardSortParamsDTOToJSON(value['sortOptions']),
    };
}

